<template>
    <div class="innerManuscript">
        <h3>内部原创稿件</h3>
        <ul>
            <li v-for="item in dataList">
                <i :class="['innerArticle', item.class]"></i>
                <h4>{{item.type}}</h4>
                <p>{{item.amount}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "innerOriginalManuscript",
        data() {
            return {
                dataList: [
                    {
                        type: '文字稿',
                        amount: 2988,
                        class: 'text'
                    },
                    {
                        type: '图集稿',
                        amount: 9898,
                        class: 'pic'
                    },
                    {
                        type: '视频稿',
                        amount: 2988,
                        class: 'video'
                    },
                ]
            }
        }
    }
</script>

<style scoped>
    .innerManuscript{
        color: #fff;
        margin-left: 22px;
        margin-top: 5px;
    }
    .innerManuscript h3{
        font-size: 28px;
        margin-bottom: 47px;
    }
    .innerManuscript ul li {
        position: relative;
    }
    .innerManuscript .innerArticle{
        width: 82px;
        height: 82px;
        margin-right: 24px;
    }
    .text{
        background: url("../../../assets/images/manuscript-word.png")center center no-repeat;
        background-size: 100% 100%;
    }
    .pic{
        background: url("../../../assets/images/manuscript-pic.png")center center no-repeat;
        background-size: 100% 100%;
    }
    .video{
        background: url("../../../assets/images/manuscript-video.png")center center no-repeat;
        background-size: 100% 100%;
    }
    .innerManuscript ul{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .innerManuscript ul li{
        height: 82px;
    }
    .innerManuscript ul li * {
        float: left;
    }
    .innerManuscript ul li h4, .innerManuscript ul li p{
        font-size: 27px;
        width: calc(100% - 106px);
    }
    .innerManuscript ul li p{
        color: #4afffd;
        margin-top: 14px;
    }
</style>
